import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { UserInfo } from 'src/app/tools/models/entities/user-info';
import { Form } from '../../entities/control-tables/form';
import { Profile } from '../../entities/master-data/profile-entity';

export class ProfileRequest extends BaseRequest {
  profile : Profile;
  constructor(userInfo : UserInfo){
    super(userInfo);
    this.profile = new Profile();
  }
}